import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IDocumentReferenceProductDTO } from '@app/core/model';
import { SharedDocumentReferencesService } from '@app/shared/services/shared-document-references.service';
import { ShellService } from '@mynexus/mfe-core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentReferencesHHService extends SharedDocumentReferencesService {
  constructor(
    http: HttpClient,
    shellService: ShellService
  ) {
    super(http, shellService, 'HH')
  }

  override getDocumentReferences(
    lineOfBusinessId: string,
    reference: string
  ): Observable<IDocumentReferenceProductDTO[]> {
    return of(this.documentTypes as IDocumentReferenceProductDTO[]);
  }

  // type assignment crutch
  private documentTypes: IDocumentReferenceProductDTO[] = [
    { description: 'Initial Request', value: 'Initial Request' },
    { description: 'MD Order', value: 'MD Order' },
    { description: 'Plan of Care/485', value: 'Plan of Care/485' },
    { description: 'Evaluation', value: 'Evaluation' },
    { description: 'OASIS', value: 'OASIS' },
    { description: 'Reauth Request', value: 'Reauth Request' },
    { description: 'Patient Summary Report', value: 'Patient Summary Report' },
    { description: 'Wound Care Connect Image / Documentation', value: 'Wound Care Connect Image / Documentation' },
    { description: 'Visit Notes', value: 'Visit Notes' },
    { description: 'Resumption of Care OASIS', value: 'Resumption of Care OASIS' },
    { description: 'Recert OASIS', value: 'Recert OASIS' },
    { description: 'D/C OASIS', value: 'D/C OASIS' },
    { description: 'Retro', value: 'Retro' },
    { description: 'Additional Information', value: 'Additional Information' },
    { description: 'Duplicate', value: 'Duplicate' },
    { description: 'Miscellaneous', value: 'Miscellaneous' },
    { description: 'History and Physical', value: 'History and Physical' },
    { description: 'Discharge Summary', value: 'Discharge Summary' },
    { description: 'POA/AOR', value: 'POA/AOR' },
    { description: 'P2P', value: 'P2P' },
    { description: 'NOMNC', value: 'NOMNC' },
    { description: 'Aspire', value: 'Aspire' },
    { description: 'Intent to Deny', value: 'Intent to Deny' },
    { description: 'PSCCR', value: 'PSCCR' },
    { description: 'DENC', value: 'DENC' },
    { description: 'Provider Appeal', value: 'Provider Appeal' },
    { description: 'Member Appeal', value: 'Member Appeal' },
    { description: 'Denial Notification', value: 'Denial Notification' }
  ] as any;
}
